import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import RichEditor from "../../../components/editor/RichEditor";
import {Translate} from "../../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import Thumbnail from "../../fileManager/Components/Thumbnail";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../../components/elements/LoadingButton";
import SubTitle from "../../../components/elements/SubTitle";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import FieldCounter from "../../../components/elements/FieldCounter";
import {setStore} from "trim-redux";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import Alert from "@material-ui/lab/Alert/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import ChooseVariables from "./components/ChooseVariables";
import FormControl from "@material-ui/core/FormControl/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup/RadioGroup";
import Radio from "@material-ui/core/Radio/Radio";
import IconButton from "@material-ui/core/IconButton/IconButton";
import EditAttributesRoundedIcon from '@material-ui/icons/EditAttributesRounded';
import Hidden from "@material-ui/core/Hidden/Hidden";
import AppsRoundedIcon from '@material-ui/icons/AppsRounded';
import Link from "@material-ui/core/Link/Link";
import Feature from "../../../components/elements/Feature";
import Button from "@material-ui/core/Button/Button";
import PageviewRoundedIcon from '@material-ui/icons/PageviewRounded';
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import Typography from "@material-ui/core/Typography/Typography";

class MakeCategory extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
        this.EditorChild = React.createRef();

    }
    state = {
        fields:{
            name:"",
            description:"",
            icon:"",
        },
        content:{
            HTML: '',
            RAW: null,
            PlainText: ''
        },
        attribute_id:0,
        show_in_home:0,
        attributes:[],
        thumbnail: 1,
        errors:{},
        categories:[],
        defaultCategory:null,
        slug:null,
        loading: true,
        SubmitLoading: false,
        confirmed: true,
        hide_products: true,
        parentId:null,
        id:this.props.match.params.id,
        editMode:false
    };
    classes = this.props.classes;
    async componentDidMount(){
        await this.loadAttributes();

        if(!!this.state.id){
            this.setState({
                editMode:true
            })
            await this.loadData();
        }
        await this.loadParents();
    }
    async loadParents(){
        let loginToken = localStorage.getItem('ACT');

        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/categories/quickViewForChooser`, config)
                .then(response => {
                    let categories = response.data.filter((item) => {
                        return item.id !== parseInt(this.id)
                    });
                    categories.map((item,index) =>{
                        return item.id === this.state.parentId ? this.setState({
                            defaultCategory: index,
                        }) : null
                    })
                    this.setState({
                        categories: response.data,
                        loading:false,
                        SubmitLoading:false
                    })
                })
                .catch(error => {
                    this.setState({
                        loading:false,
                        SubmitLoading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
                loading:false,
                SubmitLoading:false
            });
            this.setState({
                loading:false,
                SubmitLoading:false
            })
        }
    }
    async loadAttributes(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.get(`${defaultVariabls.url}/attributes/getAll`, config)
            .then(response => {
                this.setState({
                    attributes: response.data,
                })
            })
            .catch(error => {
                this.setState({
                    loading:false,
                    SubmitLoading:false
                })
            })
    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    handleThumbImage(id){
        this.setState({
            thumbnail: id
        })
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/category/get/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            name: response.data.name,
                            description: !!response.data.description ? response.data.description : '',
                            icon: !!response.data.icon ? response.data.icon : '',
                        },
                        thumbnail: response.data.thumbnail.id,
                        parentId: response.data.parent_id,
                        attribute_id: !!parseInt(response.data.attribute_id) ? parseInt(response.data.attribute_id) : 0,
                        confirmed: response.data.confirmed,
                        hide_products: response.data.hide_products,
                        show_in_home: response.data.show_in_home,
                        slug: response.data.slug,
                        content: {
                            HTML: response.data.html,
                            RAW: response.data.raw,
                        },
                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(validator.isEmpty(fields.name)){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }

        //Description
        if(fields.description !== null ) {
            if (fields.description.length > 150) {
                formIsValid = false;
                errors['description'] = Translate.maxLength150;
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { fields,thumbnail,content,id,editMode,confirmed,hide_products,parentId,attribute_id,show_in_home} = this.state;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('html', content.HTML);
        data.append('raw', content.RAW);
        data.append('plainText', content.PlainText);
        data.append('id', id ? id : 0);
        data.append('description', fields.description);
        data.append('icon', fields.icon);
        data.append('thumbnail', thumbnail);
        data.append('parent_id', parentId);
        data.append('attribute_id', parseInt(attribute_id));
        data.append('confirmed',  confirmed ? 1 : 0);
        data.append('hide_products',  hide_products ? 1 : 0);
        data.append('show_in_home',  show_in_home ? 1 : 0);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/category/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.dataEdited : Translate.dataAdded, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
                if(!this.state.editMode){
                    this.props.history.push(`/manage/categories`);
                }
            })
            .catch(error => {
                console.log(error.response);
                if(error.response.status === 403){
                    this.props.enqueueSnackbar(Translate.categoryPublishedBefore, {
                        variant: 'error',
                    });
                }else{
                    this.props.enqueueSnackbar(editMode ?  Translate.dataEditingFailed : Translate.dataAddingFailed, {
                        variant: 'error',
                    });
                }

                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }
    handleClickDescription(){
        let {fields,content} = this.state;
        if(fields['description'] === ''){
            fields['description'] = content.PlainText === null ? null : content.PlainText.slice(0, 150);
            this.setState({fields})
        }
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleOutPut(code){
        this.setState({
            content:code
        })
    }
    handleChangeConfirmed(){
        this.setState({
            confirmed: !this.state.confirmed,
        })
    }
    handleChangeHideProducts(){
        this.setState({
            hide_products: !this.state.hide_products,
        })
    }
    handleParent(value){
        if(value === null){
            this.setState({
                parentId:''
            })
        }else{
            this.setState({
                parentId:value.id
            })
        }
    }
    render(){
        let {fields, errors,SubmitLoading,thumbnail,content,editMode,confirmed,show_in_home,slug,categories,parentId,attribute_id,attributes} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={editMode ? Translate.editCategory : Translate.makeCategory}>
            {

                        <Grid container spacing={2} justify="center">
                            <Grid item xs={12} md={8} lg={9}>
                                <AppCard
                                    title={editMode ? Translate.editCategory : Translate.makeCategory}
                                    action={
                                        <BreadCrumbs singleLevel firstText={editMode ? Translate.editCategory : Translate.makeCategory}/>
                                    }>
                                    {
                                        this.state.loading ? <AppCardLoaderFields/> :
                                            <Grid container spacing={2} justify="center" alignItems="center">
                                                <Grid item xs={12}>
                                                    <Alert
                                                        severity="info"
                                                        action={
                                                            <FormControlLabel
                                                                style={{marginRight:10,color: !confirmed ? "#ed1d1d" : ""}}
                                                                control={
                                                                    <Switch
                                                                        checked={confirmed}
                                                                        onChange={this.handleChangeConfirmed.bind(this)}
                                                                        value={confirmed}
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={confirmed ? Translate.confirmed : Translate.unConfirmed}
                                                            />
                                                        }
                                                    >
                                                        {Translate.confirmationStatus}
                                                    </Alert>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        variant="outlined"
                                                        name="name"
                                                        label={Translate.categoryName}
                                                        type="text"
                                                        id="name"
                                                        value={fields.name}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['name']}
                                                        helperText={errors['name']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Autocomplete
                                                        options={categories}
                                                        defaultValue={categories[this.state.defaultCategory]}
                                                        onChange={(event, value) => this.handleParent(value)}
                                                        getOptionLabel={option => option.name}
                                                        renderInput={params => (
                                                            <TextField
                                                                margin="normal"
                                                                {...params}
                                                                label={Translate.categoryParentName}
                                                                variant="outlined"
                                                                fullWidth
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RichEditor ref={this.EditorChild} Output={this.handleOutPut.bind(this)} input={content.RAW}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        margin="normal"
                                                        multiline
                                                        fullWidth
                                                        name="description"
                                                        label={Translate.seoDescription}
                                                        placeholder={Translate.seoDescription}
                                                        type="text"
                                                        id="description"
                                                        rows="4"
                                                        value={fields.description}
                                                        onChange={this.handleChange.bind(this)}
                                                        onClick={this.handleClickDescription.bind(this)}
                                                        error = {!!errors['description']}
                                                        helperText={errors['description']}
                                                    />
                                                    <FieldCounter length={fields.description.length} max={150}/>
                                                </Grid>
                                                {/*<Grid item xs={12}>
                                                    <Alert
                                                        severity="warning"
                                                        variant="outlined"
                                                        action={
                                                            <FormControlLabel
                                                                style={{marginRight:10}}
                                                                control={
                                                                    <Switch
                                                                        checked={hide_products}
                                                                        onChange={this.handleChangeHideProducts.bind(this)}
                                                                        value={hide_products}
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={hide_products ? Translate.yes : Translate.no}
                                                            />
                                                        }
                                                    >
                                                        {Translate.doYouWantToHideProducts}
                                                    </Alert>
                                                </Grid>*/}
                                                <Hidden mdDown>
                                                    <Grid item xs={12}>
                                                        <LoadingButton
                                                            variant="contained"
                                                            color="primary"
                                                            onClick = {this.handleSubmit.bind(this)}
                                                            loading = {SubmitLoading}
                                                        >
                                                            {editMode ? Translate.editCategory : Translate.makeCategory}
                                                        </LoadingButton>
                                                    </Grid>
                                                </Hidden>
                                            </Grid>
                                    }
                                </AppCard>
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <Grid container spacing={2}>
                                    <Hidden smDown>
                                        <Grid item xs={12} style={{paddingTop: 0}}>
                                            <LoadingButton
                                                variant="contained"
                                                color="primary"
                                                style={{width: "100%"}}
                                                onClick={this.handleSubmit.bind(this)}
                                                loading={SubmitLoading}
                                            >
                                                {editMode ? Translate.editCategory : Translate.makeCategory}
                                            </LoadingButton>
                                        </Grid>
                                    </Hidden>
                                    {
                                        !!editMode && !!confirmed ?
                                            <Button
                                                component="a"
                                                target="_blank"
                                                size="small"
                                                startIcon={<PageviewRoundedIcon/>}
                                                href={`${defaultVariabls.website}/product-category/${slug}`}
                                                color="primary"
                                            >
                                                {Translate.viewCategory}
                                            </Button>
                                            : null
                                    }
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12}>
                                                            <SubTitle>{Translate.ThumbnailTitle}</SubTitle>
                                                            <Thumbnail rounded ref={this.ThumbChild}
                                                                       handleThumbImage={this.handleThumbImage.bind(this)}
                                                                       initial={thumbnail}/>
                                                        </Grid>
                                                        {
                                                            !parentId &&
                                                            <Grid item xs={12}>
                                                                <FormControl required  component="fieldset">
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={show_in_home} onChange={() => this.setState({show_in_home:!show_in_home})} />}
                                                                        label={Translate.showProductsInHome}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                        }
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Feature check="variable_products">
                                    <Grid item xs={12}>
                                        <AppCard
                                            title={Translate.chooseAttribute}
                                            action={
                                                <IconButton>
                                                    <EditAttributesRoundedIcon color="primary"/>
                                                </IconButton>
                                            }>
                                            {
                                                this.state.loading ?
                                                    <AppCardLoaderFields/> :
                                                    <FormControl component="fieldset">
                                                        <RadioGroup aria-label="attribute" name="attribute" value={attribute_id} onChange={(e)=> this.setState({attribute_id:parseInt(e.target.value)})}>
                                                            {
                                                                attributes.map((attribute,index) => (
                                                                    <FormControlLabel key={index} value={attribute.id} control={<Radio />} label={attribute.name} />
                                                                ))
                                                            }
                                                            <FormControlLabel value={0} control={<Radio />} label={Translate.nonOfThem} />

                                                        </RadioGroup>
                                                    </FormControl>
                                            }
                                        </AppCard>
                                    </Grid>
                                    </Feature>
                                    {
                                        !parentId &&
                                        <Grid item xs={12}>
                                            <AppCard
                                                title={Translate.chooseCategoryIcon}
                                                action={
                                                    <IconButton>
                                                        <AppsRoundedIcon color="primary"/>
                                                    </IconButton>
                                                }>
                                                {
                                                    this.state.loading ?
                                                        <AppCardLoaderFields/> :
                                                        <TextField
                                                            variant="outlined"
                                                            margin="normal"
                                                            fullWidth
                                                            name="icon"
                                                            label={Translate.icon}
                                                            placeholder={Translate.icon}
                                                            type="text"
                                                            value={fields.icon}
                                                            onChange={this.handleChange.bind(this)}
                                                            error = {!!errors['icon']}
                                                            helperText={errors['icon']}
                                                        />
                                                }
                                                <Link target="_blank" href="https://fontawesome.com/v5/search">{Translate.iconsList}</Link>
                                            </AppCard>
                                        </Grid>
                                    }
                                    <Hidden mdUp>
                                        <Grid item xs={12} style={{paddingTop: 0}}>
                                            <LoadingButton
                                                variant="contained"
                                                color="primary"
                                                style={{width: "100%"}}
                                                onClick={this.handleSubmit.bind(this)}
                                                loading={SubmitLoading}
                                            >
                                                {editMode ? Translate.editCategory : Translate.makeCategory}
                                            </LoadingButton>
                                        </Grid>
                                    </Hidden>
                                </Grid>


                            </Grid>
                        </Grid>
                }
            </AppAnimate>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(MakeCategory)));